export default __webpack_public_path__ + "static/what-we-do-technology-55c9c64e3b08ef1f9b7245bc5f568aca.jpg";